exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip[data-v-5ac60244]{line-height:35px;margin-bottom:10px}\n", ""]);

// exports
